import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class GetAccountDetailsUseCase extends BaseUseCase {
    constructor(loginRepo) {
        super();
        this.loginRepo = loginRepo;
    }
    async fetchResult(req) {
        return await this.loginRepo.getAccountDetails(req);
    }
}
export default GetAccountDetailsUseCase;
